export const letterK = {
  nouns: [
    {"coffee": ["Kaffee", "Kaffees", "der", "die", "m"]},
    {"card": ["Karte", "Karten", "die", "die", "f"]},
    {"credit card": ["Kreditkarte", "Kreditkarten", "die", "die", "f"]},
    {"potato": ["Kartoffel", "Kartoffeln", "die", "die", "f"]},
    {"checkout": ["Kasse", "Kassen", "die", "die", "f"]},
    {"child": ["Kind", "Kinder", "das", "die", "n"]},
    {"kindergarten": ["Kindergarten", "Kindergärten", "der", "die", "m"]},
    {"cinema": ["Kino", "Kinos", "das", "die", "n"]},
    {"kiosk": ["Kiosk", "Kioske", "der", "die", "m"]},
    {"class": ["Klasse", "Klassen", "die", "die", "f"]},
    {"clothing": ["Kleidung", "Kleidungen", "die", "die", "f"]},
    {"suitcase": ["Koffer", "Koffer", "der", "die", "m"]},
    {"colleague": ["Kollege", "Kollegen", "der", "die", "m"]},
    {"account": ["Konto", "Konten", "das", "die", "n"]},
    {"head": ["Kopf", "Köpfe", "der", "die", "m"]},
    {"kitchen": ["Küche", "Küchen", "die", "die", "f"]},
    {"cake": ["Kuchen", "Kuchen", "der", "die", "m"]},
    {"pen": ["Kugelschreiber", "Kugelschreiber", "der", "die", "m"]},
    {"refrigerator": ["Kühlschrank", "Kühlschränke", "der", "die", "m"]},
    {"customer": ["Kunde", "Kunden", "der", "die", "m"]},
    {"course": ["Kurs", "Kurse", "der", "die", "m"]}
  ],
  verbs: [
    {"to buy": ["kaufen", "kaufe", "kaufst", "kauft", "kauft", "kauft", "kaufen", "kauft", "kaufen", "kaufen"]},
    {"to know": ["kennen", "kenne", "kennst", "kennt", "kennt", "kennt", "kennen", "kennt", "kennen", "kennen"]},
    {"to learn": ["lernen", "lerne", "lernst", "lernt", "lernt", "lernt", "lernen", "lernt", "lernen", "lernen"]},
    {"to cook": ["kochen", "koche", "kochst", "kocht", "kocht", "kocht", "kochen", "kocht", "kochen", "kochen"]},
    {"to come": ["kommen", "komme", "kommst", "kommt", "kommt", "kommt", "kommen", "kommt", "kommen", "kommen"]},
    {"to can": ["können", "kann", "kannst", "kann", "kann", "kann", "können", "könnt", "können", "können"]},
    {"to cost": ["kosten", "koste", "kostest", "kostet", "kostet", "kostet", "kosten", "kostet", "kosten", "kosten"]},
    {"to get": ["kriegen", "kriege", "kriegst", "kriegt", "kriegt", "kriegt", "kriegen", "kriegt", "kriegen", "kriegen"]},
    {"to care for": ["kümmern", "kümmere", "kümmerst", "kümmert", "kümmert", "kümmert", "kümmern", "kümmert", "kümmern", "kümmern"]},
    {"to have": ["haben", "habe", "hast", "hat", "hat", "hat", "haben", "habt", "haben", "haben"]},
    {"to be": ["sein", "bin", "bist", "ist", "ist", "ist", "sind", "seid", "sind", "sind"]},
    {"to go": ["gehen", "gehe", "gehst", "geht", "geht", "geht", "gehen", "geht", "gehen", "gehen"]},
    {"to see": ["sehen", "sehe", "siehst", "sieht", "sieht", "sieht", "sehen", "seht", "sehen", "sehen"]},
    {"to give": ["geben", "gebe", "gibst", "gibt", "gibt", "gibt", "geben", "gebt", "geben", "geben"]},
    {"to do": ["machen", "mache", "machst", "macht", "macht", "macht", "machen", "macht", "machen", "machen"]}
  ],
  examples: {
    nominative: [
      {
        german: '___ Kaffee ist heiß.',
        english: 'The coffee is hot.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Kind spielt.',
        english: 'The child plays.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Karte ist neu.',
        english: 'The card is new.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Kino ist groß.',
        english: 'The cinema is big.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Kollege arbeitet.',
        english: 'The colleague works.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Küche ist sauber.',
        english: 'The kitchen is clean.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Kuchen schmeckt.',
        english: 'The cake tastes good.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Kurs beginnt.',
        english: 'The course begins.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Kunde kommt.',
        english: 'The customer comes.',
        answer: 'Der',
        case: 'nominative'
      }
    ],
    accusative: [
      {
        german: 'Ich trinke ___ Kaffee.',
        english: 'I drink coffee.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Sie kauft ___ Karte.',
        english: 'She buys the card.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Er besucht ___ Kind.',
        english: 'He visits the child.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Wir brauchen ___ Koffer.',
        english: 'We need a suitcase.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Du siehst ___ Kino.',
        english: 'You see the cinema.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Ich kaufe ___ Kreditkarte.',
        english: 'I buy a credit card.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Sie hat ___ Kurs.',
        english: 'She has a course.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Er kennt ___ Kollegen.',
        english: 'He knows the colleague (male).',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Wir essen ___ Kuchen.',
        english: 'We eat the cake.',
        answer: 'den',
        case: 'accusative'
      }
    ],
    dative: [
      {
        german: 'Ich helfe ___ Kind.',
        english: 'I help the child.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Sie spricht mit ___ Kollegin.',
        english: 'She speaks with the colleague (female).',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Er gibt ___ Kind ___ Kuchen.',
        english: 'He gives the child the cake.',
        answer: 'dem den',
        case: 'dative'
      },
      {
        german: 'Wir danken ___ Kellner.',
        english: 'We thank the waiter.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Du gehst zu ___ Kino.',
        english: 'You go to the cinema.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Ich arbeite für ___ Kunden.',
        english: 'I work for the customers.',
        answer: 'die',
        case: 'dative'
      },
      {
        german: 'Sie kocht in ___ Küche.',
        english: 'She cooks in the kitchen.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Er schreibt mit ___ Kugelschreiber.',
        english: 'He writes with the pen.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Wir wohnen bei ___ Kindergarten.',
        english: 'We live near the kindergarten.',
        answer: 'dem',
        case: 'dative'
      }
    ],
    translations: [
      {
        english: 'The coffee is hot.',
        german: 'Der Kaffee ist heiß.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'She buys the card.',
        german: 'Sie kauft die Karte.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'I help the child.',
        german: 'Ich helfe dem Kind.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'The child plays.',
        german: 'Das Kind spielt.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'We need a suitcase.',
        german: 'Wir brauchen einen Koffer.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The course begins.',
        german: 'Der Kurs beginnt.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'You go to the cinema.',
        german: 'Du gehst zum Kino.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The kitchen is clean.',
        german: 'Die Küche ist sauber.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'He knows the colleague.',
        german: 'Er kennt den Kollegen.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'She cooks in the kitchen.',
        german: 'Sie kocht in der Küche.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'We eat the cake.',
        german: 'Wir essen den Kuchen.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'I work for the customers.',
        german: 'Ich arbeite für die Kunden.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The customer comes.',
        german: 'Der Kunde kommt.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'They speak with the colleagues.',
        german: 'Sie sprechen mit den Kollegen.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'You need a credit card.',
        german: 'Du brauchst eine Kreditkarte.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The cake tastes good.',
        german: 'Der Kuchen schmeckt gut.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'We live near the kindergarten.',
        german: 'Wir wohnen beim Kindergarten.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'He writes with the pen.',
        german: 'Er schreibt mit dem Kugelschreiber.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'I drink coffee.',
        german: 'Ich trinke Kaffee.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The cinema is big.',
        german: 'Das Kino ist groß.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'She has a course.',
        german: 'Sie hat einen Kurs.',
        type: 'translation',
        caseType: 'accusative'
      }
    ],
    conjugations: [
      {
        question: 'How do you conjugate "to buy" for "I"?',
        answer: 'kaufe',
        verb: 'kaufen',
        verbEnglish: 'to buy',
        subject: 'ich',
        conjugation: 'kaufe'
      },
      {
        question: 'How do you conjugate "to know" for "you" (informal)?',
        answer: 'kennst',
        verb: 'kennen',
        verbEnglish: 'to know',
        subject: 'du',
        conjugation: 'kennst'
      },
      {
        question: 'How do you conjugate "to learn" for "he"?',
        answer: 'lernt',
        verb: 'lernen',
        verbEnglish: 'to learn',
        subject: 'er',
        conjugation: 'lernt'
      },
      {
        question: 'How do you conjugate "to cook" for "we"?',
        answer: 'kochen',
        verb: 'kochen',
        verbEnglish: 'to cook',
        subject: 'wir',
        conjugation: 'kochen'
      },
      {
        question: 'How do you conjugate "to come" for "they" (formal)?',
        answer: 'kommen',
        verb: 'kommen',
        verbEnglish: 'to come',
        subject: 'Sie',
        conjugation: 'kommen'
      },
      {
        question: 'What is simple past of "to buy" for "I"?',
        answer: 'kaufte',
        verb: 'kaufen',
        verbEnglish: 'to buy',
        subject: 'ich',
        conjugation: 'kaufte'
      },
      {
        question: 'What is simple past of "to know" for "she"?',
        answer: 'kannte',
        verb: 'kennen',
        verbEnglish: 'to know',
        subject: 'sie',
        conjugation: 'kannte'
      },
      {
        question: 'What is simple past of "to learn" for "we"?',
        answer: 'lernten',
        verb: 'lernen',
        verbEnglish: 'to learn',
        subject: 'wir',
        conjugation: 'lernten'
      },
      {
        question: 'What is simple past of "to cook" for "he"?',
        answer: 'kochte',
        verb: 'kochen',
        verbEnglish: 'to cook',
        subject: 'er',
        conjugation: 'kochte'
      }
    ]
  }
}
